import React, { Component } from 'react';
import { connect } from 'react-redux';

import Aux from '../Auxiliary/Auxiliary';
import classes from './Layout.module.css';
import SideDrawer from '../../Navigation/SideDrawer/SideDrawer';
import Navbar from '../../Navigation/Navbar/Navbar';

class Layout extends Component {
    
    state = {
        showSidedrawer: false
    }

    sideDrawerClosedHandler = () =>{
        this.setState({showSidedrawer: false});
    }

    sideDrawerToggle = () => {
        this.setState( ( prevState ) => {
            return {showSidedrawer: !prevState.showSidedrawer};
        });
    }
    render(){
        return(
            <Aux>
                <Navbar
                isAuth={this.props.isAuthenticated}
                drawerToggleClicked={this.sideDrawerToggle}/>
                <SideDrawer 
                isAuth={this.props.isAuthenticated}
                open={this.state.showSidedrawer} 
                closed={this.sideDrawerClosedHandler}/>
                <main className={classes.Content}>
                    {this.props.children }
                </main>
            </Aux>
        );
    }
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAdmin
    }
}

export default connect(mapStateToProps)(Layout);